/** @module Classes */ /** typedoc */
class DspArtistRelease {
    constructor() {
        this.name = null;
        this.pictureUrl = null;
        this.releaseDate = null;
        this.url = null;
    }
}
class DspArtist {
    constructor() {
        this.dspName = null;
        this.id = null;
        this.recentRelease = null;
        this.name = null;
        this.url = null;
    }
}

export { DspArtist, DspArtistRelease };
